import type { ListItemData } from "@ms/shared-components/components/GenericPanelList";
import type { CompsListItemData } from "@ms/shared-components/comps/CompsList";
import { Admin } from "../config/types";

/**
 * 角色列表项构建（显示定义）
 * 将后端角色数据映射为 GenericPanelList 的展示结构
 */
export const buildRoleListItem = (role: any): ListItemData => {
  const id = role.id;
  // 计算权限数量（数据来源优先级：permissionCount -> permissions.length -> number）
  let permissionCount = 0;
  if (role.permissionCount !== undefined) {
    permissionCount = role.permissionCount;
  } else if (Array.isArray(role.permissions)) {
    permissionCount = role.permissions.length;
  } else if (typeof role.permissions === "number") {
    permissionCount = role.permissions;
  }

  return {
    id,
    leftContent: role.name || "未命名角色",
    rightContent: String(permissionCount),
    roleData: {
      id,
      name: role.name || "未命名",
      code: role.code || "",
      parentId: role.parentId,
    },
  };
};

/**
 * 管理员列表项构建（显示定义）
 * 将管理员原始数据映射为 GenericPanelList 的展示结构
 */
export const buildAdminListItem = (admin: Admin): ListItemData => {
  return {
    id: admin.id,
    leftContent: `${admin.name} (${admin.account})`,
    rightContent: String(admin.permissionCount ?? 0),
    adminData: admin,
  };
};

/**
 * 某角色下的管理员 → CompsList 项（右侧「角色成员」只读列表）
 */
export function buildRoleMemberCompsItem(admin: Record<string, unknown>, index: number): CompsListItemData {
  const id = String(admin.id ?? `member-${index}`);
  const account = String(admin.adminAccount ?? admin.account ?? "");
  const name = String(admin.adminName ?? admin.name ?? "");
  const left = name ? (account ? `${name} (${account})` : name) : account || id || "—";
  /** 与 msLogin removeAdminFromRole：内置 admin 账号不可从角色移除（不区分大小写） */
  const memberRemoveDisabled = account.toLowerCase() === "admin";
  return {
    id,
    leftContent: left,
    rightContent: admin.adminPhone ? String(admin.adminPhone) : undefined,
    adminRecord: admin,
    memberRemoveDisabled,
  };
}


